import { Outlet } from 'react-router-dom';
import { useState } from 'react';
import Header from './Header';
import Footer from './Footer';

// ================================================================
//  SIDEBAR SWITCH
//  NEW sidebar (active) : keep [NEW] import + [NEW] return, comment [OLD] ones
//  OLD sidebar          : keep [OLD] import + [OLD] return, comment [NEW] ones
// ================================================================

// [NEW] Active sidebar
import AppSidebar from './Sidebar/AppSidebar';

// [OLD] Previous sidebar — uncomment below & comment the line above to switch back
// import Sidebar from './Sidebar/index';

const Layout = () => {
  const [collapsed, setCollapsed] = useState(false);

  // [NEW] Layout for AppSidebar — uses app-layout / app-layout--collapsed
  return (
    <div className={`app-layout ${collapsed ? 'app-layout--collapsed' : ''}`}>
      <AppSidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      <div className="app-layout__content">
        {/* <Header sidebarOpen={collapsed} setIsSidebarOpen={setCollapsed} /> */}
        <main className="app-layout__main">
          <Outlet />
        </main>
        <Footer />
      </div>
    </div>
  );

  /* [OLD] Layout for Sidebar — uncomment this return block & comment the one above to switch back
  return (
    <div className="app-wrapper">
      <Sidebar sidebarOpen={collapsed} setIsSidebarOpen={setCollapsed} />
      <div className="app-content">
        <Header sidebarOpen={collapsed} setIsSidebarOpen={setCollapsed} />
        <div className="page-body" style={{ padding: '1.5rem 1.25rem' }}>
          <Outlet />
        </div>
        <Footer />
      </div>
    </div>
  );
  */
};

export default Layout;
